import React, { useEffect, useState } from 'react';
import { ReactComponent as GroupIcon } from '../../static/icons/group.svg';
import Button from '../../components/UI/Button';
import Table from '../../components/atoms/table';
import { getGroupsInCompany } from '../../api/group-setting';
import toast from 'react-hot-toast';
import { Container, Header } from './GroupSettingStyles';
import AddManageGroupMembers from '../../components/group-setting/AddManageGroupMembers';
import DeleteGroup from '../../components/group-setting/DeleteGroup';
import { getUserListingInCompany } from '../../api/user-api';
import CreateGroupModal from '../../components/group-setting/modals/CreateGroupModal';
import CountLabel from 'components/atoms/CountLabel';

const GroupSettingPage = () => {
  const [groups, setGroups] = useState([]);
  const [company, setCompany] = useState('');
  const [companyMembers, setCompanyMembers] = useState([]);
  const [createGroupModal, setOpenCreateGroupModal] = useState(false);
  const [openManageMembersModal, setOpenManageMembersModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const getCompanyMembers = async () => {
    const UserListingRes = await getUserListingInCompany();
    const UserListingData = UserListingRes?.data;
    const usersList = UserListingData?.users?.map((user) => {
      return { ...user, label: user?.name || user?.email || user?.uuid };
    });
    setCompanyMembers(usersList || []);
  };

  const getSetGroupList = async () => {
    try {
      setLoading(true);
      const groupInCompanyRes = await getGroupsInCompany();
      const groupInCompanyData = groupInCompanyRes?.data;
      setGroups(groupInCompanyData?.groups || []);
      setCompany(groupInCompanyData?.company_name || '');
    } catch (e) {
      const { error = '', message = '' } = e?.response?.data || {};
      toast.error(error || message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSetGroupList();
    getCompanyMembers();
  }, []);

  const handleGroupCreateSuccess = (newGroup) => {
    setGroups((prevGroups) => [...prevGroups, newGroup]);
  };

  const handleGroupDelete = (deletedGroupId) => {
    setGroups((prevGroups) => prevGroups.filter((group) => group._id !== deletedGroupId));
  };

  const handleUpdateGroupSuccess = (updatedGroup) => {
    setGroups((prevGroups) => {
      return prevGroups.map((group) =>
        group._id === updatedGroup.group_id ? { ...group, members: updatedGroup.members } : group
      );
    });
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Group Name',
      cell: ({ row }) => (
        <span onClick={() => setOpenManageMembersModal(true)} className="underline ">
          {row.original.name}
        </span>
      )
    },
    {
      header: 'Members',
      cell: ({ row }) => <span>{row?.original?.members?.length}</span>
    },
    {
      header: 'Add/Manage Members',
      cell: ({ row }) => (
        <AddManageGroupMembers
          onUpdateGroupSuccess={handleUpdateGroupSuccess}
          group={row?.original}
          companyMembers={companyMembers}
          openModal={openManageMembersModal}
          setOpenModal={setOpenManageMembersModal}
        />
      )
    },
    {
      header: 'Action',
      cell: ({ row }) => (
        <DeleteGroup
          groupName={row?.original?.name}
          groupId={row?.original?._id}
          onDeleteSuccess={handleGroupDelete}
        />
      )
    }
  ];

  return (
    <Container className="bg-gradient-to-b from-gradientLight-100 to-gradientLight-200">
      <Header>
        <div>
          <h1 className="text-xl font-semibold">{company}</h1>
          <p className="text-sm">
            <CountLabel
              loading={loading}
              length={groups?.length}
              singularLabel="Group"
              pluralLabel="Groups"
            />
          </p>
        </div>
        <Button
          onClick={() => setOpenCreateGroupModal(true)}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded">
          <GroupIcon />
          <span>Create Group</span>
        </Button>
      </Header>

      <Table columns={columns} data={groups} />
      <CreateGroupModal
        onCreateSuccess={handleGroupCreateSuccess}
        companyMembers={companyMembers}
        open={createGroupModal}
        onClose={() => setOpenCreateGroupModal(false)}
      />
    </Container>
  );
};

export default GroupSettingPage;
